import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mt-5 flex flex-wrap items-baseline gap-2.5" }
const _hoisted_2 = {
  class: "text-xs text-gray-500",
  "data-cy": "conflict-full-count"
}
const _hoisted_3 = {
  key: 0,
  class: "overflow-hidden rounded border border-gray-200 bg-white",
  "data-cy": "conflict-full-matches"
}
const _hoisted_4 = {
  key: 1,
  class: "rounded border border-amber-200 bg-amber-50 px-3.5 py-3 text-xs text-gray-800",
  "data-cy": "conflict-no-full-matches"
}
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = {
  class: "ml-1.5 text-xs text-gray-500",
  "data-cy": "conflict-partial-count"
}
const _hoisted_7 = { class: "mb-3 max-w-[76ch] text-xs text-gray-500" }
const _hoisted_8 = {
  key: 0,
  class: "overflow-hidden rounded border border-gray-200 bg-white",
  "data-cy": "conflict-partial-matches"
}
const _hoisted_9 = {
  key: 1,
  class: "text-xs text-gray-500"
}

import { ref, watch } from 'vue';
import ConflictResultRow from './ConflictResultRow.vue';
import type { ConflictResultRow as ConflictRow } from '../models/conflictTypes';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConflictResultList',
  props: {
    fullMatches: {},
    partialMatches: {}
  },
  emits: ["open"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const expanded = ref<string | undefined>(
  props.fullMatches.length ? undefined : 'partial',
);

watch(
  () => props.fullMatches.length,
  (count) => {
    expanded.value = count ? undefined : 'partial';
  },
);

/** Consecutive rows for the same record are one finding shown from several fields. */
function isGrouped(rows: ConflictRow[], index: number): boolean {
  return index > 0 && rows[index - 1].recordId === rows[index].recordId;
}

/** The page calls this before printing — a collapsed panel prints as nothing. */
function expandPartials(): void {
  expanded.value = 'partial';
}

__expose({ expandPartials });

return (_ctx: any,_cache: any) => {
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "text-base font-medium" }, "Full matches", -1)),
      _createElementVNode("span", _hoisted_2, _toDisplayString(__props.fullMatches.length), 1),
      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "ml-auto text-xs text-gray-500" }, " Open a result for contact details and every field searched ", -1))
    ]),
    (__props.fullMatches.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.fullMatches, (row, index) => {
            return (_openBlock(), _createBlock(ConflictResultRow, {
              key: `${row.recordId}-${index}`,
              row: row,
              grouped: isGrouped(__props.fullMatches, index),
              onOpen: _cache[0] || (_cache[0] = ($event: any) => (emit('open', $event)))
            }, null, 8, ["row", "grouped"]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, " No full matches. Everything below matched only some of the words in its name. ")),
    _createVNode(_component_v_expansion_panels, {
      modelValue: expanded.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((expanded).value = $event)),
      class: "mt-5",
      variant: "accordion",
      "data-cy": "conflict-partial-panel"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_expansion_panel, { value: "partial" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_expansion_panel_title, null, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_5, [
                  _cache[5] || (_cache[5] = _createTextVNode(" Partial matches ", -1)),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(__props.partialMatches.length), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_expansion_panel_text, null, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_7, [
                  (!__props.fullMatches.length && __props.partialMatches.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "font-medium text-gray-700" }, " No full matches were found. These are the closest. ", -1)),
                        _cache[7] || (_cache[7] = _createTextVNode(" Some but not all of the words in a name matched. ", -1))
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" Some but not all of the words in a name matched. Always here, never hidden — closest first. ")
                      ], 64))
                ]),
                (__props.partialMatches.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.partialMatches, (row, index) => {
                        return (_openBlock(), _createBlock(ConflictResultRow, {
                          key: `${row.recordId}-${index}`,
                          row: row,
                          "show-fraction": "",
                          grouped: isGrouped(__props.partialMatches, index),
                          onOpen: _cache[1] || (_cache[1] = ($event: any) => (emit('open', $event)))
                        }, null, 8, ["row", "grouped"]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_9, "None."))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})